import React from 'react';
import LoadNowIcon from '../../../assets/svgs/LoadNowIcon.svg';
import ChageCassetteIcon from '../../../assets/svgs/ChangeCasetteLogo.svg';
import Delivering from '../../../assets/svgs/Delivering.svg';
import { LoadingOrderOpsStatus } from 'constants/orderConstants';
import { Box } from '@mui/material';
import { WaitingImpatientlyIcon } from '../../../components/WaitingImpatientlyIcon';

type PadStatusProps = {
  orderNumber: string;
  loadingStatus: LoadingOrderOpsStatus;
  switchingPadName: string;
  store?: any;
};

const PadStatus = ({
  orderNumber,
  loadingStatus,
  switchingPadName,
  store
}: PadStatusProps) => {
  if (!orderNumber) {
    return (
      <div className="flex flex-col items-start">
        <h1 className="text-4xl text-mannamono-label">No Orders</h1>
      </div>
    );
  }

  const renderStatusWithLogo = (text: string, icon: string | React.JSX.Element, bgColor: string, textColor: string) => {
    const displayNumber = orderNumber.slice(-5);
    const fontSize = displayNumber.length >= 5 ? 'text-8xl' : 'text-9xl';
    
    return (
      <div className="flex flex-col items-start">
        <h1 className={`${fontSize} ${textColor}`}>{displayNumber}</h1>
        <div className="flex items-center gap-3">
          <div className={`pl-4 pr-6 rounded-3xl flex justify-start gap-3 p-3 items-center ${bgColor} text-white text-3xl`}>
            {typeof icon === 'string' ? <img className="h-8" alt={`${text} Icon`} src={icon} /> : icon}
            {text}
          </div>
          {store?.logo && (
            <Box sx={{ 
              width: 48, 
              height: 48, 
              border: '1px solid #D9DBE9', 
              borderRadius: 1, 
              overflow: 'hidden',
              position: 'relative'
            }}>
              <img
                alt="store logo"
                src={store.logo}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%'
                }}
              />
            </Box>
          )}
        </div>
      </div>
    );
  };

  switch (loadingStatus) {
    case LoadingOrderOpsStatus.CHANGE_CASSETTE:
      return renderStatusWithLogo(
        'Change Cassette on Landing',
        ChageCassetteIcon,
        'bg-mannasecodary-default',
        'text-mannasecodary-default'
      );
    case LoadingOrderOpsStatus.DISPATCHED:
      return renderStatusWithLogo(
        'Dispatched',
        Delivering,
        'bg-mannamono-label',
        'text-mannamono-label'
      );
    case LoadingOrderOpsStatus.DELIVERED:
      return renderStatusWithLogo(
        'Returning',
        Delivering,
        'bg-mannamono-label',
        'text-mannamono-label'
      );
    case LoadingOrderOpsStatus.LOAD_NOW:
      return renderStatusWithLogo(
        'Load Now',
        LoadNowIcon,
        'bg-mannablue-default',
        'text-mannablue-default'
      );
    case LoadingOrderOpsStatus.WAIT:
      return renderStatusWithLogo(
        'Wait',
        <WaitingImpatientlyIcon size={32} />,
        'bg-mannasecodary-default',
        'text-mannasecodary-default'
      );
    default: //LoadingOrderOpsStatus.COMPLETE:
      const displayNumber = orderNumber.slice(-5);
      const fontSize = displayNumber.length >= 5 ? 'text-8xl' : 'text-9xl';
      
      return (
        <div className="flex flex-col items-start">
          <h1 className={`${fontSize} text-mannamono-default`}>{displayNumber}</h1>
          {store?.logo && (
            <Box sx={{ 
              width: 48, 
              height: 48, 
              border: '1px solid #D9DBE9', 
              borderRadius: 1, 
              overflow: 'hidden',
              position: 'relative',
              marginTop: 2
            }}>
              <img
                alt="store logo"
                src={store.logo}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%'
                }}
              />
            </Box>
          )}
        </div>
      );
    }
};

export default PadStatus;